<template>
  <SelectBox
    @option:selected="$emit('option:selected', $event)"
    :options="items"
    :validActivated="validActivated"
    :label="label"
    :noLabel="noLabel"
    :clearable="clearable"
    :searchable="false"
    :value="value"
    @input="$emit('input', $event)"
  >
    <template #selected-option="{ item }">
      {{ optionField ? item[optionField] : item.label }}
    </template>
    <template #option="{ item }">
      {{ optionField ? item[optionField] : item.label }}
    </template>
  </SelectBox>
</template>

<script>
import SelectBox from "../Base/Inputs/SelectBox.vue";
export default {
  components: {
    SelectBox,
  },
  props: {
    value: {
      default: null,
    },
    noLabel: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    validActivated: {
      default: false,
      type: Boolean,
    },
    items: {
      default: () => [],
      type: Array,
    },
    optionField: {
      default: "title",
      type: String,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style></style>
